var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_vm._t("default"),_vm._v(" "),_c('RevisionUpdateModal',_vm._g({attrs:{"is-shown":_vm.isRequiredRevisionUpdate}},( _obj = {}, _obj[_vm.emitEvents.emitEventWhenClickReloadButton] = _vm.reloadPage, _obj )))],2)}
var staticRenderFns = []

export { render, staticRenderFns }